import { IMAGE, LAYOUT_LIST } from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';

interface ImageDefinition {
  id?: string;
  pictures?: [
    {
      id?: string;
      mediaUrl?: string;
      name?: string;
    },
    {
      id?: string;
      mediaUrl?: string;
      name?: string;
    }
  ];
}

export const Images1: Translator = sequence => {
  const item = (sequence.items ? sequence.items[0] : []) as ImageDefinition;
  const bgImage =
    item?.pictures && item?.pictures.length >= 0
      ? item?.pictures[0]?.mediaUrl
      : false;
  const image =
    item?.pictures && item?.pictures.length >= 1
      ? item?.pictures[1]?.mediaUrl
      : false;

  let newSequence = sequence;

  if (sequence && sequence.items && sequence.items.length) {
    const newItem = {
      ...sequence?.items[0],
      pictures: [
        {
          id:
            item.pictures && item.pictures.length > 0
              ? item.pictures[0].id
              : item.id,
          name:
            item && item.pictures && item.pictures[0] && item.pictures[0]?.name
              ? item?.pictures[0]?.name
              : 'background',
          mediaUrl: bgImage,
          backgroundSizeForMobile: '100%',
          __typename: 'Picture'
        }
      ]
    };

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    newSequence = { ...sequence, items: [newItem] };
  }

  const root = translate(newSequence, () => null);

  root.items.push({
    id: 'layout_list',
    type: LAYOUT_LIST,
    values: {
      align: 'center'
    },
    items: !image
      ? []
      : [
          {
            type: IMAGE,
            id: '2',
            items: [],
            values: {
              url: image,
              alt: item?.pictures?.[1]?.name,
              borderRadius: '20px'
            }
          }
        ]
  });

  return root;
};
